import React, { FC } from 'react';
import { Col, Row, Skeleton } from 'antd';
import { DashboardCard } from 'common/components/DashboardCard';
import { useAppSelector } from 'app/store/store.hooks';
import { TrackStoreSummary } from 'entities/TrackStore/components/TrackStoreSummary';
import { TrackStoreWeeklyGrid } from 'entities/TrackStore/components/TrackStoreWeeklyGrid';

export const TrackStoreOverall: FC = () => {
  const { trackStoreSummary, trackStoreSummaryLoading, trackStoreWeeklyGrid, trackStoreWeeklyGridLoading } =
    useAppSelector((state) => state.trackStore);

  return (
    <DashboardCard className="tsrt-overall-card" title="Overall" variant="overall">
      <Row gutter={{ sm: 40, xxl: 64 }} className="p-7 pt-5" justify="space-between">
        <Col span={12}>
          {trackStoreSummaryLoading ? (
            <Skeleton active paragraph={{ rows: 4 }} title={false} />
          ) : (
            <TrackStoreSummary summary={trackStoreSummary} />
          )}
        </Col>

        <Col span={12}>
          {trackStoreWeeklyGridLoading ? (
            <Skeleton active paragraph={{ rows: 4 }} title={false} />
          ) : (
            <TrackStoreWeeklyGrid weeklyGrid={trackStoreWeeklyGrid} />
          )}
        </Col>
      </Row>
    </DashboardCard>
  );
};
